import { Component } from "react";
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../actions/fillCombo_action';
import { cityActionId, stallEventActionId, stallListActionId, B2b_meetingStatusActionId, toastError, toastSuccess } from "../../../utils/constants";
import { emailValidator } from "../../../utils/Validator";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import Pagination from "../../../utils/pagination";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import { useNavigate } from "react-router-dom";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import { data } from "jquery";
import { getDelegate_All_B2b_MeetingList_action, getDelegate_B2B_Users_action, UpdateDelegate_All_B2b_Meeting_action } from "../../../actions/admin_module_action/delegate_All_B2B_Meeting_action/delegate_All_B2B_Meeting_action";
import Footer from "../../../common_components/Footer";


class Delegate_All_B2B_Meeting extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            currentPage: 1,
            countryList: [],
            All_B2B_MeetingList: [],
            CompanyName: '',
            Status: '',
            All_B2B_MeetingID: '',
            diplayStatus: 1,
            exhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            B2b_meetingStatusList: [],
            B2BDate: '',
            B2BMeetingID: '',
            isB2bStatus: 2
        }
        this.updateItem = this.updateItem.bind(this)
    }

    componentDidMount() {
        this.getFillList(B2b_meetingStatusActionId, '', '', '', '', '')

        this.getAll_B2B_MeetingList()
    }

    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        const { } = this.state
        return new Promise((resolve, reject) => {
            this.setState({ isLoading: true })
            this.props
                .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
                .then((data) => {
                    if (data.error != 1) {
                        // country list
                        if (actionID === B2b_meetingStatusActionId) {
                            this.setState({
                                B2b_meetingStatusList: data.data,
                                isLoading: false
                            })
                        }
                        resolve(true)
                    }
                    this.setState({ isLoading: false })
                })
                .catch((e) => {
                    console.log(e);
                });
        })
    }

    isModalOpen(B2BMeetingID) {
        const { isOpen } = this.state
        console.log("B2BMeetingID------>", B2BMeetingID)
        this.setState({ isOpen: !isOpen, B2BMeetingID: B2BMeetingID, })
    }

    record(list) {
        return (
            <>
                {list.length > 0 && list.map((item) => (
                    <div class="company-section mt-4 p-2" style={{ boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px;" }}>
                        <h5 class="pt-1 p-1 pb-0"><i class="fa fa-calendar"></i> {moment(item.MeetingDate).format("Do MMM, YYYY")} | <i
                            class="fa fa-clock-o"></i> {moment(item.B2BStartTime).format("HH:mm")} - {moment(item.B2BEndTime).format("HH:mm")}
                            {this.state.isB2bStatus != 5 && <button type="btn"
                                class="btn btn-outline-primary p-1 px-3" style={{ float: "right" }}
                                onClick={(e) => this.isModalOpen(item.B2BMeetingID)}
                            >Update
                                Status</button>}</h5>
                        <div class="row p-3 pt-1 pb-1">
                            <div class="col-md-3 p-0">
                                <div class="company-info">
                                    <h5 class="text-primary">{item.B2BBookedByCompanyName}</h5>
                                    <p class="mb-2"><i class="fa fa-user-circle-o"
                                        aria-hidden="true"></i> {item.B2BBookedByPersonName} | {item.B2BBookedBydesignation}</p>
                                    {item.B2BBookedByOwnerName != null && item.B2BBookedByOwnerName != ' ' && item.B2BBookedByOwnerName != undefined && <p class="mb-2"><i class="fa fa-user-circle-o"
                                        aria-hidden="true"></i> {item.B2BBookedByOwnerName} | {item.B2BBookedByDesignationName}
                                    </p>}
                                </div>
                                <div class="matching-countries">
                                    <p class="mb-2">Country: <span class="px-2">{item.B2BBookedByCountryName}</span>
                                    </p>
                                </div>

                            </div>
                            <div class="col-md-2">
                                <h3 class="text-primary">⇔ </h3>
                            </div>


                            <div class="col-md-5 p-0">
                                <div class="company-info">
                                    <h5 class="text-primary">{item.B2BBookedToCompanyName}</h5>
                                    <p class="mb-2"><i class="fa fa-user-circle-o"
                                        aria-hidden="true"></i> {item.B2BBookedToPersonName} | {item.B2BBookedTodesignation}</p>
                                    <p class="mb-2"><i class="fa fa-user-circle-o"
                                        aria-hidden="true"></i> {item.B2BBookedToOwnerName} | {item.B2BBookedToDesignationName}
                                    </p>
                                </div>
                                <div class="matching-countries">
                                    <p class="mb-2">Country: <span class="px-2">{item.B2BBookedToCountryName}</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                ))
                }

            </>
        )
    }

    getAll_B2B_MeetingList() {
        this.setState({ isLoading: true })
        const { CompanyName, Status, B2BDate, } = this.state
        this.props.getDelegate_All_B2b_MeetingList_action(
            B2BDate != '' ? moment(B2BDate).format('YYYY-MM-DD') : null,
            Status != '' ? Status : 2,
            CompanyName != '' ? CompanyName : null,
        )
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ All_B2B_MeetingList: data.data, isB2bStatus: Status != '' ? Status : 2 })
                    this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    UpdateDelegate_All_B2b_Meeting() {
        this.setState({ isLoading: true })
        const { B2BMeetingID, AdminRemark } = this.state
        this.props.UpdateDelegate_All_B2b_Meeting_action(B2BMeetingID, AdminRemark)
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess("Submitted Successfully")
                    this.setState({ isLoading: false, AdminRemark: '', isOpen: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    clearSearch() {
        const { Stateno, PANNo } = this.state
        this.setState({
            Status: '',
            B2BDate: '',
            CompanyName: '',
        })
        setTimeout(() => {
            this.getAll_B2B_MeetingList()
        }, 100);
    }

    handleBooked() {
        this.props.navigate('/booked_All_B2B_Meeting', { state: { is_add: true, } })
    }


    updateItem(item) {
        const { All_B2B_MeetingList } = this.state
        this.setState({ currentPage: item });
        const recordsPerPage = 10;
        const indexOfLastRecord = item * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = All_B2B_MeetingList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(All_B2B_MeetingList.length / recordsPerPage)
        this.setState({ startIndex: recordsPerPage * (item - 1) });
    }

    render() {
        const { isLoading, currentPage, All_B2B_MeetingList, CompanyName, Status, B2BDate, isOpen, AdminRemark } = this.state
        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = All_B2B_MeetingList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(All_B2B_MeetingList.length / recordsPerPage)
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                <ToastContainer />
                <HeaderWithLogo />

                <>
                    <div className="app-content with-dr-container com-height">
                        <AdminDrawer />
                        <div className="row">
                            <div className="step-name">
                                <p>All B2B Meeting's</p>
                            </div>
                        </div>
                        <div className="m-3">
                            <div className="">
                                <div className="row ">
                                    <div className="col-md-3">
                                        <label>Company Name</label>
                                        <input
                                            Event="text"
                                            className="form-control"
                                            value={CompanyName}
                                            onChange={(e) => this.setState({ CompanyName: e.target.value, })}
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label >Meeting Date</label>
                                        <DatePicker selected={B2BDate}
                                            onChange={(date) =>
                                                this.setState({
                                                    B2BDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                    arrivalDateErr: ""
                                                })}
                                            dateFormat={"dd/MM/yyyy"} className="form-control"
                                            peekNextMonth
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            placeholderText="DD/MM/YYYY"
                                            dayClassName={() => "example-datepicker-day-class"}
                                            popperClassName="example-datepicker-class" />
                                    </div>
                                    <div className="col-md-3">
                                        <label>Status</label>
                                        <select className="form-control"
                                            value={Status}
                                            onChange={(e) => this.setState({ Status: e.target.value })}
                                        >
                                            <option value={''}>Select</option>
                                            {
                                                this.state.B2b_meetingStatusList.length > 0 && this.state.B2b_meetingStatusList.map((data) => (
                                                    <option key={data.B2BStatusID} value={data.B2BStatusID}>{data.Name}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                    <div className="col-md-3" style={{ textAlign: 'left' }}>
                                        <label>&emsp;</label>
                                        <button Event="button" className="btn ad-fil-btn"
                                            onClick={e => this.getAll_B2B_MeetingList()}
                                        >
                                            Search
                                        </button>
                                        <button Event="button" className="btn btn-outline-danger"
                                            onClick={e => this.clearSearch()}
                                        >
                                            Clear
                                        </button>
                                        {/* <button Event="button" className="btn ad-fil-btn"
                                            onClick={e => this.handleBooked()}
                                        >
                                            Book a meeting
                                        </button> */}
                                    </div>
                                </div>
                            </div>
                            {/* <div className="col-md-12 mb-2">
                                <div
                                    className="btn-group mb-1"
                                    role="group"
                                    aria-label="Basic example"
                                    style={{ float: "right" }}
                                >
                                    <button Event="button" className="btn ad-fil-btn"
                                        onClick={e => this.handleAdd()}
                                    >
                                        Booked
                                    </button>
                                </div>
                            </div> */}
                            <div className="col-md-12 pl-0">
                                <div class="card-body p-1 text-left">
                                    {this.record(currentRecords)}
                                </div>
                                <div className="row">
                                    <div className="col-md-9 pl-0">
                                        <div className="mt-2 float">
                                            {
                                                All_B2B_MeetingList.length > 0 ?
                                                    <Pagination
                                                        nPages={nPages}
                                                        currentPage={currentPage}
                                                        setCurrentPage={this.updateItem}
                                                    /> : <></>
                                            }

                                        </div>
                                    </div>
                                    <div className="col-md-3 text-right">
                                        <div className="tab-rec mt-3" style={{ float: "right" }}>
                                            <p>{`${currentPage} of ${nPages} pages`}</p>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                    <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                        <div className="modal-dialog" style={{ marginTop: '10%' }}>
                            <div className="modal-content confirm-logout">
                                <div className="row p-3">
                                    <div className="col-md-12">
                                        <label>Remark</label>
                                        <textarea
                                            rows={4}
                                            cols={6}
                                            maxLength={1000}
                                            className="form-control"
                                            value={AdminRemark}
                                            onChange={(e) => this.setState({ AdminRemark: e.target.value })}
                                        />
                                    </div>
                                </div>
                                {/* <div class="modal-body">
                                <div class="row">
                                </div>
                            </div> */}
                                <div class="modal-footer p-1">
                                    <div class="form-group text-right mod-fot">
                                        <button Event="button" class="btn btn-save-pop"
                                            onClick={(e) => this.UpdateDelegate_All_B2b_Meeting(this.state.deleteID)}
                                        >Mark as Completed</button>
                                        <button Event="button" class="btn btn-can-pop" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                            onClick={() => this.setState({ isOpen: false })}
                                        >Cancel</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </Modal>
                </>
                <Footer />
            </>)
    }

}
export default withRouter(connect(null, { fill_action, getDelegate_All_B2b_MeetingList_action, getDelegate_B2B_Users_action, UpdateDelegate_All_B2b_Meeting_action })(Delegate_All_B2B_Meeting));